import {register} from '../modules/eventMap';

const remove = (el) => {
    const {eventHandlerToRemove} = el.dataset;
    el.removeAttribute(eventHandlerToRemove);
};

const eventHandler = () => {
    register('eventHandler', {
        remove
    });
};

export {eventHandler};
